import { jsx } from "panel";
import { FilterBarEl } from "common/components/filter-bar";
import { TableEl } from "common/components/table";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "../toggle/types";
export function template() {
  const {
    columns,
    customHeaderBarRenderer,
    getFilterSortedMenuSections,
    filterBarSelectActionRenderer,
    rowDetailsRenderer,
    selectedTab,
    tabs
  } = this.state;
  const hideFilterBar = this.attr(`hide-filter-bar`) || this.attr(`render-empty-state-slot`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".filter-bar-table"
  }, !this.attr(`hide-header`) ? /* @__PURE__ */ jsx("div", {
    sel: ".filter-bar-table-header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".filter-bar-table-tabs"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    attrs: {
      elref: this.helpers.getTabsElRef(),
      selected: selectedTab,
      theme: this.attr(`tab-theme`) || ToggleTheme.TabBar,
      "style-override": this.attr(`tab-theme`) ? null : `.mp-toggle-option { margin-left: 15px; } .mp-toggle.theme-tabbar { border-bottom: none; }`,
      options: tabs
    },
    on: {
      select: this.helpers.handleTabChange
    }
  }), /* @__PURE__ */ jsx("slot", {
    attrs: { name: `actions` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".filter-bar-table-header-bar"
  }, customHeaderBarRenderer ? customHeaderBarRenderer() : null, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `custom-header-bar` }
  }))) : null, !hideFilterBar ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(FilterBarEl, {
    attrs: this.helpers.getBarAttrs(),
    on: {
      updateInput: this.helpers.handleFilterSearchChange,
      clickAction: this.helpers.handleClickAction,
      clearSelected: this.helpers.handleClearSelected,
      changeFilter: this.helpers.handleFilterSelectChange,
      applyFilter: this.helpers.handleApplyFilter,
      filterMenuChange: this.helpers.handleFilterMenuChange,
      filterSelectAll: this.helpers.filterSelectAll
    },
    hook: this.attr(`sticky-titles`) ? this.helpers.stickyElemHooks : {},
    props: {
      getFilterSortedMenuSections
    }
  }, /* @__PURE__ */ jsx("div", {
    attrs: { slot: `filter-select-action` }
  }, filterBarSelectActionRenderer ? filterBarSelectActionRenderer() : null))) : null, this.attr(`render-empty-state-slot`) ? /* @__PURE__ */ jsx("slot", {
    attrs: { name: `empty-state` }
  }) : /* @__PURE__ */ jsx(TableEl, {
    attrs: this.helpers.getTableAttrs(),
    props: {
      rows: this.helpers.getTableRows(),
      rowDetailsRenderer,
      columns
    },
    on: {
      selectionChange: this.helpers.handleSelectionChange,
      numResultsChange: this.helpers.handleTableResultsChange,
      rowDetailsVisibilityChange: this.helpers.handleRowDetailsVisibilityChange,
      rowClick: this.helpers.handleRowClick,
      cellClick: this.helpers.handleCellClick,
      sortChange: this.helpers.handleSortChange,
      columnMoved: this.helpers.handleColumnMoved
    }
  }));
}
